import { render, staticRenderFns } from "./TruckTemplateWeekdaysSelect.vue?vue&type=template&id=010f7b84"
import script from "./TruckTemplateWeekdaysSelect.vue?vue&type=script&lang=ts"
export * from "./TruckTemplateWeekdaysSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports